/* src/app/ui/form-controls/auto-complete/auto-complete.component.scss */
:host ::ng-deep .icon-size {
  font-size: 18px;
  display: flex;
  align-items: center;
}
:host .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
:host {
}
:host ::ng-deep .mat-mdc-form-field .mdc-notched-outline {
  border-radius: 2px !important;
}
:host ::ng-deep .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__leading,
:host ::ng-deep .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__notch,
:host ::ng-deep .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #888ea5 !important;
}
:host ::ng-deep .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__leading {
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
}
:host ::ng-deep .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__trailing {
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
}
:host ::ng-deep .mat-mdc-form-field.mat-focused .mdc-notched-outline .mdc-notched-outline__leading,
:host ::ng-deep .mat-mdc-form-field.mat-focused .mdc-notched-outline .mdc-notched-outline__notch,
:host ::ng-deep .mat-mdc-form-field.mat-focused .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: var(--pbds-primary) !important;
  border-width: 1px !important;
}
:host ::ng-deep .mat-mdc-form-field.is-invalid .mdc-notched-outline .mdc-notched-outline__leading,
:host ::ng-deep .mat-mdc-form-field.is-invalid .mdc-notched-outline .mdc-notched-outline__notch,
:host ::ng-deep .mat-mdc-form-field.is-invalid .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: var(--danger) !important;
  border-width: 1px !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-autocomplete,
:host ::ng-deep .mat-mdc-form-field .mdc-text-field__input,
:host ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
  border-radius: 2px !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  height: 39px !important;
  min-height: 39px !important;
  border-radius: 2px !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-infix {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  min-height: auto !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-autocomplete {
  height: auto !important;
  line-height: 23px !important;
  padding: 0 !important;
  font-size: 0.875rem !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-autocomplete-value {
  line-height: 23px !important;
  font-size: 0.875rem !important;
  padding: 0 !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-autocomplete-placeholder {
  font-size: 0.875rem !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-autocomplete {
  background-color: white !important;
}
:host ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
:host ::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-full {
  background-color: #fff !important;
  border-color: var(--pbds-primary) !important;
}
:host ::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-full::after {
  color: var(--pbds-primary) !important;
}
:host ::ng-deep .mat-pseudo-checkbox-checked::after {
  top: 0 !important;
  left: 0 !important;
  width: 10px !important;
  height: 5px !important;
  border-bottom: 2px solid var(--pbds-primary) !important;
  border-left: 2px solid var(--pbds-primary) !important;
}
::ng-deep .cdk-overlay-container {
  z-index: 1056;
}
::ng-deep .mat-mdc-autocomplete-panel .mat-mdc-option {
  height: auto !important;
  min-height: 48px;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
::ng-deep .mat-mdc-autocomplete-panel .mat-mdc-option .mdc-list-item__primary-text {
  white-space: normal !important;
  overflow-wrap: break-word;
  line-height: 1.4 !important;
  display: block !important;
}
/*# sourceMappingURL=auto-complete.component.css.map */
